import {
  Dashboard as DashboardIcon,
  LocalShippingTwoTone,
  LocalGroceryStore as LocalGroceryStoreIcon,
} from "@mui/icons-material";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";



export const options = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    route: "/dashboard",
  },
  {
    title: "Pedidos",
    icon: <LocalShippingTwoTone />,
    route: "/pedidos",
  },
  {
    title: "Total de productos",
    icon: <LocalGroceryStoreIcon />,
    route: "/total-productos",
  },
  {
    title: "Logs de acceso",
    icon: <LoginIcon />,
    route: "/logs",
  },
  {
    title: "Cerrar Sesión",
    route: "/logout",
    icon: <LogoutIcon />,
  },
];